import { atom, selector } from "recoil";
//import type { Schema } from "../../amplify/data/resource";
import type { User } from "../../amplify/api/types";

// Atom for storing the dictionary of users
export const usersState = atom<User[]>({
    key: "usersState",
    default: [],
});

// Atom to track when users should be refreshed
export const usersRefreshTrigger = atom<number>({
    key: "usersRefreshTrigger",
    default: 0,
});

// Selector for getting users by username
export const usersByUsernameState = selector({
    key: "usersByUsernameState",
    get: ({ get }) => {
        const users = get(usersState);
        const userMap: Record<string, User> = {};

        users.forEach((user) => {
            userMap[user.username] = user;
        });

        return userMap;
    },
});

// Selector for getting user display names
export const userDisplayNamesState = selector({
    key: "userDisplayNamesState",
    get: ({ get }) => {
        const users = get(usersState);
        const displayNames: Record<string, string> = {};

        users.forEach((user) => {
            // Use full name if available, otherwise use email
            const fullName =
                user.givenName || user.familyName
                    ? `${user.givenName || ""} ${user.familyName || ""}`.trim()
                    : user.email;

            displayNames[user.username] = fullName;
        });

        return displayNames;
    },
});
